import { Table } from "react-bootstrap"
import { DragHandlerIcon } from "./dragHandlerIcon"
export const ConfigFormRowDragOverlay = ({ item }) => {
    return (
        <Table hover className="workflow-config-table config-form-table">
            <tbody>
                <tr>
                    <td className="pt-3"><DragHandlerIcon /></td>
                    <td>{ item.name }</td>
                    <td className="text-end">
                        <i className='fi-edit me-2'></i>
                        <i className='fi-trash'></i>
                    </td>
                </tr>
            </tbody>
        </Table>
    )
}